import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { Tooltip } from '@zendesk/forethought-elements';
import { AIStudioIconButton } from 'src/components/global-ai-studio/AIStudioIconButton';
import { AIStudioTriggerButton } from 'src/components/global-ai-studio/AIStudioTriggerButton';

interface SidebarAITriggerProps {
  isLoading?: boolean;
  isMinimized: boolean;
  onOpenStudio: () => void;
}

const SidebarAITrigger = ({
  isLoading,
  isMinimized,
  onOpenStudio,
}: SidebarAITriggerProps) => {
  const { t } = useTranslation('app');

  return (
    <Box display='flex' padding={isMinimized ? '0 0 8px' : '0 12px 8px'}>
      <Tooltip
        fullWidth
        placement='right'
        PopperProps={{
          modifiers: [
            {
              name: 'offset',
              options: { offset: [0, -8] },
            },
          ],
        }}
        tooltipContent={isMinimized ? t('sidebar.aiStudio') : undefined}
      >
        {isMinimized ? (
          <AIStudioIconButton
            ariaLabel={t('sidebar.aiStudio')}
            isLoading={isLoading}
            onClick={onOpenStudio}
            sx={{ margin: '0 auto' }}
          />
        ) : (
          <AIStudioTriggerButton
            isLoading={isLoading}
            label={t('sidebar.aiStudio')}
            onClick={onOpenStudio}
          />
        )}
      </Tooltip>
    </Box>
  );
};

export default SidebarAITrigger;
